import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root',
})

export class SweetAlertService {
    confirm(msg : string, title ?: string){
      return Swal.fire({
        title: title,
        text: msg,
        icon: "question",
        /*heightAuto : true,
        width: 400,*/
        loaderHtml : '<span>operation en cour ...</span>',
        showCancelButton: true,
        //draggable : true,
        confirmButtonColor: "#fa1403e5",
        cancelButtonColor: "rgba(70, 70, 70, 1)",
        confirmButtonText: "Oui, ",
        cancelButtonText: "Non",
        showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
        })
    }

    success(title ?: string, timer ?: number){
      return Swal.fire({
        title: "Operation reussie !!!",
        width: 600,
        icon: "success",
        timer : timer??2000,
         showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
      });
    }

    error(title : string){
      return Swal.fire({
        title: title,
        width: 600,
        icon: "error",
        timer : 5000,
         showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
      });
    }

    warning(title : string){
      return Swal.fire({
        title: title,
        width: 600,
        icon: "warning",
        timer : 5000,
         showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
      });
    }

    info(title : string){
      return Swal.fire({
        title: title,
        width: 600,
        icon: "info",
        timer : 5000,
         showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
      });
    }
}
